<template>
<v-main>
  <v-layout justify-center class="mt-2">
    <v-card width="1200" class="rounded-xl">
      <h1>
        <p class="text-center font-weight-bold">
          Cadastrar Help {{ textTipoFuncionario }}
        </p>
        <!-- {{recepcionista}} -->
      </h1>

      <v-form ref="form" v-model="valid" class="mx-4">
        <v-autocomplete v-model="tituloEscolhido" item-value="idTituloHelp" item-text="titulo" :items="listaTitulos" :readonly="!isEditing" label="Título" :rules="[(v) => !!v || 'Adicione uma Título !!']" persistent-hint required />

        <v-text-field v-model="subtituloForm" :rules="[(v) => !!v || 'Adicione uma Subtítulo !!']" label="Subtítulo" required />
        <br>
        <v-textarea v-model="textoForm" name="input-7-1" box label="Texto" :rules="[(v) => !!v || 'Adicione uma Texto !!']" auto-grow />
        <v-alert :value="sucessoCadastrar" color="success" icon="check_circle" outlined>
          Dados cadastrador com sucesso !!
        </v-alert>
      </v-form>
      <v-card-actions>
        <v-spacer />
        <v-btn rounded dark :disabled="desabilitarSalvar" :class="{ red: !valid, green: valid }" @click="submit">
          Cadastrar
        </v-btn>
        <v-btn text to="/help" @click="">
          <v-icon left>
            keyboard_backspace
          </v-icon>
          voltar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-layout>
</v-main>
</template>

<script>
import administradorDesenvolvimentoService from '../../services/administradorDesenvolvimento.service'
import administradorUnidadeService from "../../services/administradorUnidade.service";

export default {
  name: "FuncionariosOnline",
  props: {
    msg: String
  },
  data() {
    return {
      textTipoFuncionario: "",
      sucessoCadastrar: false,
      page: 1,
      desabilitarSalvar: false,
      desabilitarVoltar: false,
      clicouEditar: false,
      valid: false,
      carregandoTabela: false,
      tituloEscolhido: "",
      listaTitulos: [],
      subtituloForm: '',
      idHelpForm: '',
      textoForm: "",
      search: "",
      intFuncionarioOnline: 1,
      qtdVagasVazio: false,
      tipo: "",
      diaSemanaLista: "",
      dialogErroQuantidade: false,
      listaHelp: [],
      respostaServidor: false,
      isEditing: true,
      dialog2: false,
      user: null,
    };
  },
  mounted() {

    console.log('parametro cadastrar', this.$route.params.tipo);
    this.tipo = this.$route.params.tipo
    if (!this.$route.params.tipo) {
      this.$router.push('/help')
      return
    }
    if (this.tipo == 4) {
      this.textTipoFuncionario = 'Médico'
    }
    if (this.tipo == 2) {
      this.textTipoFuncionario = 'Recepcionista'
    }
    if (this.tipo == 5) {
      this.textTipoFuncionario = 'Administrador de Unidade'
    }

    this.user = this.$store.getters.usuario;
    this.retornarTituloHelp()

  },

  created() {
    console.log("created...");
  },

  methods: {
    limitarTamanhoString(text) {
      if (text.length > 80) {
        return text.substr(0, 80) + "..."
      }
    },

    reditarHelp(item) {
      console.log('editar help', item)
      this.retornarTituloHelp()
      this.idHelpForm = item.idHelp
      this.tituloEscolhido = item.idTituloHelp
      this.subtituloForm = item.subtitulo
      this.textoForm = item.texto
      this.clicouEditar = true
    },

    retornarTituloHelp() {
      administradorDesenvolvimentoService.administradorDesenvolvimento.
      retornarTituloHelp()
        .then(rsp => {
          console.log('rsp retornarTituloHelp:', rsp.data)
          this.listaTitulos = rsp.data
          //this.servicoTeste = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarHelp() {
      this.carregandoTabela = true
      this.desabilitarVoltar = true
      this.desabilitarSalvar = true
      administradorDesenvolvimentoService.administradorDesenvolvimento
        .retornarHelp(this.tipo)
        .then(rsp => {
          console.log('rsp retornarHelp:', rsp);
          if (rsp.status == 200) {
            this.listaHelp = rsp.data
            this.carregandoTabela = false
            this.desabilitarVoltar = false
            this.desabilitarSalvar = false
            this.clicouEditar = false
          }
        })
        .catch(err => {
          //handle your error here
          this.carregandoTabela = false
          this.blockMethod = false
          console.log(err)
        })

    },

    mudarTabelaPeloTipo(tipo) {
      this.intFuncionarioOnline = tipo;
      this.tipo = tipo
      this.retornarHelp()
      console.log("em mudar tabela");

    },

    submit() {
      if (this.$refs.form.validate()) {
        //this.desabilitarSalvar = true   
        //this.desabilitarVoltar = true  
        this.sucessoCadastrar = false

        administradorDesenvolvimentoService.administradorDesenvolvimento
          .cadastrarHelp(this.tituloEscolhido, this.subtituloForm,
            this.textoForm, this.tipo)
          .then(rsp => {
            console.log('rsp cadastrarHelp:', rsp.data)
            if (rsp.data == true) {
              this.sucessoCadastrar = true
              this.desabilitarSalvar = false
              this.desabilitarVoltar = false
              this.$refs.form.reset()
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },
  }
};
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}

.input-qty {
  width: 60px;
  height: 25px;
  border: 2px solid #80cbc4;
  border-radius: 5px;
}

.rounded-card {
  border-radius: 35px;
}
</style>
